// For update schedule
import { uuid } from 'uuidv4';
import { addHoursAndMinutesInMs } from "../zoomHelpers";
import createAvailability from "../zoomHelpers/createAvailability";

const updateSchedule = (dayToRender, opsTime, duration) => {
  const startTimestampInMs = new Date(parseInt(dayToRender.format('x'))).setHours(0, 0, 0, 0);
  const {
    hour,
    minutes
  } = opsTime;
  const start = addHoursAndMinutesInMs(startTimestampInMs, hour, minutes);
  const end = start + duration * 60 * 1000;
  const newTimeslot = {
    duration: duration,
    id: uuid(),
    time: {
      start,
      end
    },
    drafts: []
  };
  return {
    newTimeslot,
    newAvailabilities: createAvailability(newTimeslot, duration)
  };
};

export default updateSchedule;